import DNIBack from '../assets/img/self_inspection/DNI_atras.png';
import DNIFront from '../assets/img/self_inspection/DNI_frente.png';
import GNCTank from '../assets/img/self_inspection/GNC.png';
import DriverAirbag from '../assets/img/self_inspection/airbag-conductor.png';
import PassengerAirbag from '../assets/img/self_inspection/airbag-pasajero.png';
import CarBack from '../assets/img/self_inspection/auto_atras.png';
import CarRight from '../assets/img/self_inspection/auto_derecha.png';
import CarFront from '../assets/img/self_inspection/auto_frente.png';
import CarLeft from '../assets/img/self_inspection/auto_izquierda.png';
import Trunk from '../assets/img/self_inspection/baul.png';
import TruckBack from '../assets/img/self_inspection/camion_atras.png';
import TruckRight from '../assets/img/self_inspection/camion_derecha.png';
import TruckFront from '../assets/img/self_inspection/camion_frente.png';
import TruckLeft from '../assets/img/self_inspection/camion_izquierda.png';
import SUVBack from '../assets/img/self_inspection/camioneta_atras.png';
import SUVRight from '../assets/img/self_inspection/camioneta_derecha.png';
import SUVFront from '../assets/img/self_inspection/camioneta_frente.png';
import SUVLeft from '../assets/img/self_inspection/camioneta_izquierda.png';
import HomeTrailerBack from '../assets/img/self_inspection/casa_rodante_atras.png';
import HomeTrailerRight from '../assets/img/self_inspection/casa_rodante_derecha.png';
import HomeTrailerFront from '../assets/img/self_inspection/casa_rodante_frente.png';
import HomeTrailerLeft from '../assets/img/self_inspection/casa_rodante_izquierda.png';
import NonRollingCertificate from '../assets/img/self_inspection/certificado_no_rodamiento.png';
import Chasis from '../assets/img/self_inspection/chasis.png';
import Policy from '../assets/img/self_inspection/constancia_poliza.png';
import Generic from '../assets/img/self_inspection/foto-generica.png';
import TireSize from '../assets/img/self_inspection/medida-cubierta.png';
import LiftTruckBack from '../assets/img/self_inspection/montacarga_atras.png';
import LiftTruckRight from '../assets/img/self_inspection/montacarga_derecha.png';
import LiftTruckFront from '../assets/img/self_inspection/montacarga_frente.png';
import LiftTruckLeft from '../assets/img/self_inspection/montacarga_izquierda.png';
import MotoCycleBack from '../assets/img/self_inspection/moto_atras.png';
import MotoCycleRight from '../assets/img/self_inspection/moto_derecha.png';
import MotoCycleFront from '../assets/img/self_inspection/moto_frente.png';
import MotoCycleLeft from '../assets/img/self_inspection/moto_izquierda.png';
import GNCCard from '../assets/img/self_inspection/oblea.png';
import Odometer from '../assets/img/self_inspection/odometro.png';
import OuterWindshield from '../assets/img/self_inspection/parabrisa_exterior.png';
import InsideWindshield from '../assets/img/self_inspection/parabrisa_interior.png';
import PickupBack from '../assets/img/self_inspection/pickup_atras.png';
import PickupRight from '../assets/img/self_inspection/pickup_derecha.png';
import PickupFront from '../assets/img/self_inspection/pickup_frente.png';
import PickupLeft from '../assets/img/self_inspection/pickup_izquierda.png';
// import IDCardBack from '../assets/img/self_inspection/cedula_atras.png';
import DriverLicense from '../assets/img/self_inspection/registro_conducir.png';
import Tire from '../assets/img/self_inspection/rueda.png';
import SpareTire from '../assets/img/self_inspection/rueda_auxilio.png';
import Stereo from '../assets/img/self_inspection/stereo.png';
import UpholsteryFront from '../assets/img/self_inspection/tapizado-delantero.png';
import BlueCard from '../assets/img/self_inspection/tarjeta_azul.png';
import roof from '../assets/img/self_inspection/techo-cristal.png';
import BaseTrailerBack from '../assets/img/self_inspection/trailer_atras.png';
import CoupledTrailerBack from '../assets/img/self_inspection/trailer_atras.png';
import BaseTrailerRight from '../assets/img/self_inspection/trailer_derecha.png';
import CoupledTrailerRight from '../assets/img/self_inspection/trailer_derecha.png';
import BaseTrailerFront from '../assets/img/self_inspection/trailer_frente.png';
import CoupledTrailerFront from '../assets/img/self_inspection/trailer_frente.png';
import BaseTrailerLeft from '../assets/img/self_inspection/trailer_izquierda.png';
import CoupledTrailerLeft from '../assets/img/self_inspection/trailer_izquierda.png';

export const FLEET_SELF_INSPECTIONS = 6;

const COMMON_VEHICLE = {
  green_card_front: {
    image: DNIFront,
    title:
      'Subí una foto de tu cédula verde o azul donde se vean los datos del vehículo',
    continueBtnLabel: 'Foto de la cédula',
  },
  odometer: {
    image: Odometer,
    title: 'Subí una foto del odómetro, mostrando los kilómetros totales',
    continueBtnLabel: 'Foto del odómetro',
  },
  roof: {
    image: roof,
    title: 'Subí una foto del cristal del techo de tu auto desde el exterior',
    continueBtnLabel: 'Foto cristal del techo',
  },
  windshield_inside: {
    image: InsideWindshield,
    title: 'Subí una foto del parabrisas de tu auto desde el interior',
    continueBtnLabel: 'Foto del parabrisas',
  },
  windshield_outside: {
    image: OuterWindshield,
    title: 'Subí una foto del parabrisas de tu auto desde el exterior',
    continueBtnLabel: 'Foto del parabrisas',
  },
  car_trunk_open: {
    image: Trunk,
    title: 'Subí una foto del baúl abierto',
    continueBtnLabel: 'Foto del baúl',
  },
  driving_license: {
    image: DriverLicense,
    title: 'Subí una foto de la licencia del conductor del vehículo',
    continueBtnLabel: 'Foto de la licencia',
  },
  tire: {
    image: Tire,
    title: 'Subí una foto de una rueda',
    continueBtnLabel: 'Foto de la rueda',
  },
  gnc_tank: {
    image: GNCTank,
    title: 'Subí una foto del tanque de GNC (si aplica en tu caso)',
    continueBtnLabel: 'Foto del tanque GNC',
  },
  gnc_card: {
    image: GNCCard,
    title: 'Subí una foto de la cédula de GNC (si aplica en tu caso)',
    continueBtnLabel: 'Foto de la cédula',
  },
  green_card_back: {
    image: DNIBack,
    title:
      'Subí una foto de tu cédula verde o azul donde se vean los datos del domicilio',
    continueBtnLabel: 'Foto de la cédula',
  },
  identification_card: {
    image: DNIFront,
    title: 'Subí una foto de tu DNI',
    continueBtnLabel: 'Foto del DNI',
  },
  policy_certificate: {
    image: Policy,
    title: 'Subí una foto de la constancia de la póliza',
    continueBtnLabel: 'Foto de la póliza',
  },
  spare_tire: {
    image: SpareTire,
    title: 'Subí una foto de la rueda de auxilio',
    continueBtnLabel: 'Foto de la rueda de auxilio',
  },
  accessories: {
    image: Generic,
    title: 'Subí una foto de los accesorios',
    continueBtnLabel: 'Foto de la accesorios',
  },
  driver_airbag: {
    image: DriverAirbag,
    title: 'Subí una foto del airbag del conductor',
    continueBtnLabel: 'Foto del airbag',
  },
  passenger_airbag: {
    image: PassengerAirbag,
    title: 'Subí una foto del airbag del pasajero',
    continueBtnLabel: 'Foto del airbag',
  },
  nonrolling_certificate: {
    image: NonRollingCertificate,
    title: 'Subí una foto del certificado de no rodamiento',
    continueBtnLabel: 'Foto del certificado',
  },
  accesories: {
    image: Generic,
    title: 'Subí una foto de los accesorios',
    continueBtnLabel: 'Foto del accesorios',
  },
  damage: {
    image: Generic,
    title: 'Subí una foto del daño',
    continueBtnLabel: 'Foto del daño',
  },
  damage_centered: {
    image: Generic,
    title: 'Subí una foto del daño centrado',
    continueBtnLabel: 'Foto del daño',
  },
  damage_left: {
    image: Generic,
    title: 'Subí una foto del daño desde la izquierda',
    continueBtnLabel: 'Foto del daño',
  },
  damage_right: {
    image: Generic,
    title: 'Subí una foto del daño desde la derecha',
    continueBtnLabel: 'Foto del daño',
  },
  chassis_number: {
    image: Chasis,
    title: 'Subí una foto del número de chasis',
    continueBtnLabel: 'Foto del número de chasis',
  },
  tire_size: {
    image: TireSize,
    title: 'Subí una foto de la medida de la cubierta',
    continueBtnLabel: 'Foto de la cubierta',
  },
  car_stereo: {
    image: Stereo,
    title: 'Subí una foto del stereo',
    continueBtnLabel: 'Foto del stereo',
  },
  upholstery_front: {
    image: UpholsteryFront,
    title: 'Subí una foto del tapizado delantero',
    continueBtnLabel: 'Foto del tapizado',
  },
  car_dashboard: {
    image: InsideWindshield,
    title: 'Subí una foto del tablero completo',
    continueBtnLabel: 'Foto del tablero',
  },
  optional: {
    image: Generic,
    title: 'Subí otra foto si la consideras importante',
    continueBtnLabel: 'Foto opcional',
    optional: true,
  },
};

export const VehicleInspectionInfo: any = {
  car: {
    ...COMMON_VEHICLE,
    front: {
      image: CarFront,
      title: 'Subí una foto de la parte del frente de tu auto',
      continueBtnLabel: 'Foto del frente del auto',
    },
    back: {
      image: CarBack,
      title: 'Subí una foto de la parte de atrás de tu auto',
      continueBtnLabel: 'Foto de la parte de atrás del auto',
    },
    left: {
      image: CarLeft,
      title: 'Subí una foto del lado izquierdo de tu auto',
      continueBtnLabel: 'Foto del lado izquierdo del auto',
    },
    right: {
      image: CarRight,
      title: 'Subí una foto del lado derecho de tu auto',
      continueBtnLabel: 'Foto del lado derecho del auto',
    },
  },

  van: {
    ...COMMON_VEHICLE,
    front: {
      image: SUVFront,
      title: 'Subí una foto de la parte del frente de tu camioneta',
      continueBtnLabel: 'Foto del frente de la camioneta',
    },
    back: {
      image: SUVBack,
      title: 'Subí una foto de la parte de atrás de tu camioneta',
      continueBtnLabel: 'Foto de la parte de atrás de la camioneta',
    },
    left: {
      image: SUVLeft,
      title: 'Subí una foto del lado izquierdo de tu camioneta',
      continueBtnLabel: 'Foto del lado izquierdo de la camioneta',
    },
    right: {
      image: SUVRight,
      title: 'Subí una foto del lado derecho de tu camioneta',
      continueBtnLabel: 'Foto del lado derecho de la camioneta',
    },
  },

  pickup: {
    ...COMMON_VEHICLE,
    front: {
      image: PickupFront,
      title: 'Subí una foto de la parte del frente de tu pickup',
      continueBtnLabel: 'Foto del frente de la pickup',
    },
    back: {
      image: PickupBack,
      title: 'Subí una foto de la parte de atrás de tu pickup',
      continueBtnLabel: 'Foto de la parte de atrás de la pickup',
    },
    left: {
      image: PickupLeft,
      title: 'Subí una foto del lado izquierdo de tu pickup',
      continueBtnLabel: 'Foto del lado izquierdo de la pickup',
    },
    right: {
      image: PickupRight,
      title: 'Subí una foto del lado derecho de tu pickup',
      continueBtnLabel: 'Foto del lado derecho de la pickup',
    },
  },

  motorcycle: {
    ...COMMON_VEHICLE,
    front: {
      image: MotoCycleFront,
      title: 'Subí una foto de la parte del frente de tu moto',
      continueBtnLabel: 'Foto del frente de tu moto',
    },
    back: {
      image: MotoCycleBack,
      title: 'Subí una foto de la parte de atrás de tu moto',
      continueBtnLabel: 'Foto de la parte de atrás de tu moto',
    },
    left: {
      image: MotoCycleLeft,
      title: 'Subí una foto del lado izquierdo de tu moto',
      continueBtnLabel: 'Foto del lado izquierdo de tu moto',
    },
    right: {
      image: MotoCycleRight,
      title: 'Subí una foto del lado derecho de tu moto',
      continueBtnLabel: 'Foto del lado derecho de tu moto',
    },
    odometer: {
      image: Odometer,
      title: 'Subí una foto del odómetro, mostrando los kilómetros totales',
      continueBtnLabel: 'Foto del odómetro',
    },
    identificationCard: {
      image: BlueCard,
      title:
        'Subí una foto de tu cédula verde o azul donde se vean los datos del vehículo',
      continueBtnLabel: 'Foto de la cédula',
    },
  },

  truck: {
    ...COMMON_VEHICLE,
    front: {
      image: TruckFront,
      title: 'Subí una foto de la parte del frente de tu camión',
      continueBtnLabel: 'Foto del frente del camión',
    },
    back: {
      image: TruckBack,
      title: 'Subí una foto de la parte de atrás de tu camión',
      continueBtnLabel: 'Foto de la parte de atrás del camión',
    },
    left: {
      image: TruckLeft,
      title: 'Subí una foto del lado izquierdo de tu camión',
      continueBtnLabel: 'Foto del lado izquierdo del camión',
    },
    right: {
      image: TruckRight,
      title: 'Subí una foto del lado derecho de tu camión',
      continueBtnLabel: 'Foto del lado derecho del camión',
    },
  },

  trailer: {
    ...COMMON_VEHICLE,
    front: {
      image: BaseTrailerFront,
      title: 'Subí una foto de la parte del frente del trailer',
      continueBtnLabel: 'Foto del frente del trailer',
    },
    back: {
      image: BaseTrailerBack,
      title: 'Subí una foto de la parte de atrás del trailer',
      continueBtnLabel: 'Foto de la parte de atrás del trailer',
    },
    left: {
      image: BaseTrailerLeft,
      title: 'Subí una foto del lado izquierdo del trailer',
      continueBtnLabel: 'Foto del lado izquierdo del trailer',
    },
    right: {
      image: BaseTrailerRight,
      title: 'Subí una foto del lado derecho del trailer',
      continueBtnLabel: 'Foto del lado derecho del trailer',
    },
  },

  coupled_trailer: {
    ...COMMON_VEHICLE,
    front: {
      image: CoupledTrailerFront,
      title: 'Subí una foto de la parte del frente de tu acoplado',
      continueBtnLabel: 'Foto del frente del acoplado',
    },
    back: {
      image: CoupledTrailerBack,
      title: 'Subí una foto de la parte de atrás de tu acoplado',
      continueBtnLabel: 'Foto de la parte de atrás del acoplado',
    },
    left: {
      image: CoupledTrailerLeft,
      title: 'Subí una foto del lado izquierdo de tu acoplado',
      continueBtnLabel: 'Foto del lado izquierdo del acoplado',
    },
    right: {
      image: CoupledTrailerRight,
      title: 'Subí una foto del lado derecho de tu acoplado',
      continueBtnLabel: 'Foto del lado derecho del acoplado',
    },
  },

  home_trailer: {
    ...COMMON_VEHICLE,
    front: {
      image: HomeTrailerFront,
      title: 'Subí una foto de la parte del frente de tu casa rodante',
      continueBtnLabel: 'Foto del frente de la casa rodante',
    },
    back: {
      image: HomeTrailerBack,
      title: 'Subí una foto de la parte de atrás de tu casa rodante',
      continueBtnLabel: 'Foto de la parte de atrás de la casa rodante',
    },
    left: {
      image: HomeTrailerLeft,
      title: 'Subí una foto del lado izquierdo de tu casa rodante',
      continueBtnLabel: 'Foto del lado izquierdo de la casa rodante',
    },
    right: {
      image: HomeTrailerRight,
      title: 'Subí una foto del lado derecho de tu casa rodante',
      continueBtnLabel: 'Foto del lado derecho de la casa rodante',
    },
  },

  lift_truck: {
    ...COMMON_VEHICLE,
    front: {
      image: LiftTruckFront,
      title: 'Subí una foto de la parte del frente de tu montacarga',
      continueBtnLabel: 'Foto del frente del montacarga',
    },
    back: {
      image: LiftTruckBack,
      title: 'Subí una foto de la parte de atrás de tu montacarga',
      continueBtnLabel: 'Foto de la parte de atrás del montacarga',
    },
    left: {
      image: LiftTruckLeft,
      title: 'Subí una foto del lado izquierdo de tu montacarga',
      continueBtnLabel: 'Foto del lado izquierdo del montacarga',
    },
    right: {
      image: LiftTruckRight,
      title: 'Subí una foto del lado derecho de tu montacarga',
      continueBtnLabel: 'Foto del lado derecho del montacarga',
    },
  },
};
